import './index.scss';
import '../../common/Joyride/styles.scss';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import ManagePageLayout from '../../common/PageLayout/Manage';
import { changeToManageMode } from '../../../js/actions/appModeActionCreators';
import { setTourEnabled } from '../../../js/actions/tourActionCreators';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { imageStatuses } from '../../../js/statuses';
import ImageCard from './ImageCard';
import Joyride from 'react-joyride';
import { JoyrideStepStyle, JoyrideStepNoArrowStyle, JoyrideStartStepStyle } from '../../common/Joyride/steps';
import { browserHistory, Link } from 'react-router';
import IntroPage from '../../home/IntroPage';

const steps = [
{
  title: 'Welcome to SQL Clone',
  text: 'SQL Clone is a database provisioning tool that allows you to create database copies in seconds using just MB of disk space.<br><br><p>Take the guided tour to see how quick and easy it is to clone a database.</p>', // supports html tags
  selector: '.dashboardHeader',
  position: 'bottom',
  type: 'hover',
  isFixed: true,
  style: JoyrideStartStepStyle
},
{
  title: 'Images and clones',
  text: 'This is the dashboard that allows you to manage all your images and clones.', // supports html tags
  selector: '.dashboard-image',
  position: 'right',
  type: 'hover',
  isFixed: true,
  style: JoyrideStepStyle
  
},
{
  title: 'Creating images and clones',
  text: 'Using the navigation you can create both images and clones. <br><br>Go ahead and create an image.', // supports html tags
  selector: '.navigation',
  position: 'bottom-left',
  type: 'hover',
  isFixed: true,
  style: JoyrideStepStyle
},
];


const GettingStartedLink = ({}) => {
    return <div>
        <p>You don't have any images or clones yet.</p>
        <Link to="/dashboard/getting-started">Get started with SQL Clone</Link>
    </div>;
};

const Images = ({ images }) => {
    const imageNodes = images.map((img) => <ImageCard key={img.id} image={img} />);
    return <div className="pure-u-1-1">{imageNodes}</div>;
};

const MoreObjectsWarning = ({ images, totalImages, loadedClones, totalClones }) => {
    const moreImagesAvailable = totalImages && images.length < totalImages;
    const moreClonesAvailable = totalClones && loadedClones < totalClones;

    if (!moreImagesAvailable && !moreClonesAvailable) { return null; }

    if (moreImagesAvailable && moreClonesAvailable) {
        return <p>
            You have {totalImages} images and {totalClones} clones. 
            Displaying the latest {images.length} images and {loadedClones} clones.
        </p>;
    }

    if (moreImagesAvailable) {
        return <p>
            You have {totalImages} images. Displaying the latest {images.length}.
        </p>;
    }

    if (moreClonesAvailable) {
        return <p>
            You have {totalClones} clones. Displaying the latest {loadedClones}.
        </p>;
    }
};

const DashboardPage = React.createClass({
    componentDidMount: function () {
        this.props.alignMode();
    },
    renderImages() {
        const { images } = this.props;
        const imageNodes = images.map((img) => <ImageCard key={img.id} image={img} />);
        return !isUndefinedNullOrEmpty(images) && images.length ? (<div className="pure-u-1-1">{imageNodes}</div>) : <img src={DashboardPlaceHolder}></img>;
    },
    tourCallback(value) {
        if (value && value.type === 'finished') {
            if (!value.isTourSkipped) {
                ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'finishedDashboard',
                    eventLabel: 'End of dashboard tour'
                });
                browserHistory.push('/images/create/setup');
                
            }
            else {
                this.props.setTourEnabled('dashboard', false);
                ga('send', 'event', {
                    eventCategory: 'tour',
                    eventAction: 'skippedDashboard',
                    eventLabel: 'Skipped tour on dashboard'
                });
            }
            
        }
    },

    render: function () {
        const { images, shouldShowGettingStarted } = this.props;
        const hasAnyImages = !isUndefinedNullOrEmpty(images) && images.length > 0;

        if (shouldShowGettingStarted && !hasAnyImages) {
            return <IntroPage />;
        }

        return (
            <ManagePageLayout>
                <Joyride ref="joyride" run={this.props.tourEnabled} autoStart={true} showSkipButton={true} type="continuous" steps={steps} callback={this.tourCallback} locale={{ last: 'Create Image', next: 'Next', skip: 'Skip', back: 'Back' }} />

                <div className="dashboard">
                  <div className="pure-u-1-1">
                    <h3 className="dashboardHeader">Dashboard</h3>
                        {hasAnyImages && <div>
                            <MoreObjectsWarning {...this.props} />
                            <Images images={images} />
                        </div>}
                        {!hasAnyImages && <GettingStartedLink />}
                    </div>
                </div>
            </ManagePageLayout>
        );
    }
});

function mapStateToProps(state) {
    const allImages = Array.from(state.images.value.values());
    const existingImages = _(allImages).filter(img => img.status.state !== imageStatuses.deleted);
    const shouldShowGettingStarted = state.app.shouldShowGettingStarted;

    return {
        images: _(existingImages).sortBy(img => {
            const creationDate = Date.parse(img.createdDate);
            return -creationDate;
        }),
        shouldShowGettingStarted: shouldShowGettingStarted,
        totalImages: state.images.totalCount,
        loadedClones: state.clones.value.size,
        totalClones: state.clones.totalCount,
        tourEnabled: state.tour.dashboard

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        alignMode: () => {
            dispatch(changeToManageMode());
        },
        setTourEnabled: (tour, enabled) => {
            dispatch(setTourEnabled(tour, enabled));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardPage/index.jsx